import React from "react";
import { PhotoProvider, PhotoView } from "react-photo-view";

const products = [
  { img: "https://i.ibb.co/pRwMxWj/photo-2023-02-24-20-44-07.jpg" },
  { img: "https://i.ibb.co/cDy0N80/photo-2023-02-24-20-44-09.jpg" },
  { img: "https://i.ibb.co/jRMnLZL/photo-2023-02-24-20-44-10.jpg" },
  { img: "https://i.ibb.co/bBSRg4J/photo-2023-02-24-20-44-13.jpg" },
  { img: "https://i.ibb.co/j8y6dq3/photo-2023-02-24-20-44-15.jpg" },
  { img: "https://i.ibb.co/G0MbqmV/photo-2023-02-24-20-44-16.jpg" },
  { img: "https://i.ibb.co/BP8RtWt/photo-2023-02-24-20-44-18.jpg" },
  { img: "https://i.ibb.co/GFnmN5J/photo-2023-02-24-20-44-19.jpg" },
  { img: "https://i.ibb.co/42m6NcP/photo-2023-02-24-20-44-21.jpg" },
  { img: "https://i.ibb.co/fpD2MsZ/photo-2023-02-24-20-44-23.jpg" },
  { img: "https://i.ibb.co/kQ3tTkn/photo-2023-02-24-20-44-25.jpg" },
  { img: "https://i.ibb.co/3ztjrp3/photo-2023-02-24-20-44-27.jpg" },
  { img: "https://i.ibb.co/qWBvmsm/photo-2023-02-24-20-44-32.jpg" },
  { img: "https://i.ibb.co/JpqMDwb/photo-2023-02-24-20-44-34.jpg" },
  { img: "https://i.ibb.co/n3NsS4Y/photo-2023-02-24-20-44-37.jpg" },
  { img: "https://i.ibb.co/8ggHXZG/photo-2023-02-24-20-44-40.jpg" },
  { img: "https://i.ibb.co/1MCXT6T/photo-2023-02-24-20-43-57.jpg" },
];

const Gallery = () => {
  return (
    <section className="py-16 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="text-center max-w-3xl mx-auto mb-14" data-aos="fade-up">
        <span className="text-xs uppercase tracking-widest font-bold text-[#EB4438] bg-red-50 px-3.5 py-1.5 rounded-full border border-red-100">
          Manufacturing Facilities
        </span>
        <h2 className="text-3xl sm:text-4xl font-extrabold text-slate-900 mt-4 tracking-tight">
          Our Factory
        </h2>
      </div>

      <div className="pb-16 grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-5">
        <PhotoProvider>
          {products.map((p, i) => (
            <div
              key={i}
              className="group relative overflow-hidden rounded-2xl bg-slate-900 border border-slate-200/80 shadow-sm hover:shadow-xl transition-all duration-300 aspect-[4/3] cursor-pointer"
              data-aos="fade-up"
              data-aos-delay={(i % 4) * 40}
            >
              <PhotoView src={p.img}>
                <img
                  src={p.img}
                  alt="Factory production line"
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500 opacity-95 group-hover:opacity-100"
                />
              </PhotoView>
              <div className="absolute inset-0 bg-gradient-to-t from-slate-950/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none flex items-end p-4">
                <span className="text-white text-xs font-semibold flex items-center gap-1.5">
                  <span className="w-1.5 h-1.5 rounded-full bg-[#EB4438]"></span>
                  View Photo
                </span>
              </div>
            </div>
          ))}
        </PhotoProvider>
      </div>
    </section>
  );
};

export default Gallery;
